import { doGet, doPost } from '../../services';

// Courses
export const getCoursesApi = () => doGet('courses');

// Faculty
export const getFacultyApi = () => doGet('facalty'); // backend route spelling

// Results
export const getResultsApi = () => doGet('results');

// Gallery
export const getGalleryApi = () => doGet('gallery');

// Enquiry (form submit)
export const submitEnquiryApi = (payload) => doPost('enquiry', payload);

// Enquiries (admin listing)
export const getEnquiriesApi = (params) => doGet('enquiries', params);

// Contact (form submit)
export const submitContactApi = (payload) => doPost('contact', payload);